import React from "react";
import {
  CATCH_ALL_EMAIL_CAUTION_LABEL,
  CATCH_ALL_EMAIL_CAUTION_TOOLTIP,
  isCatchAllContactEmailStatus,
} from "../../utils/contactEnrichmentHelpers";
import "../../Css/Common/ContactEmailWithCaution.css";

type ContactEmailWithCautionProps = {
  email: string;
  emailStatus: string | null | undefined;
  className?: string;
  linkClassName?: string;
  variant?: "text" | "icon";
  mailtoQuery?: string;
  onLinkClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

function buildMailtoHref(email: string, mailtoQuery?: string): string {
  if (!mailtoQuery) {
    return `mailto:${email}`;
  }
  const separator = mailtoQuery.startsWith("?") ? "" : "?";
  return `mailto:${email}${separator}${mailtoQuery}`;
}

export const ContactEmailWithCaution: React.FC<ContactEmailWithCautionProps> = ({
  email,
  emailStatus,
  className,
  linkClassName,
  variant = "text",
  mailtoQuery,
  onLinkClick,
}) => {
  const isCatchAll = isCatchAllContactEmailStatus(emailStatus);
  const mailtoHref = buildMailtoHref(email, mailtoQuery);
  const iconTitle = isCatchAll
    ? `${email} — ${CATCH_ALL_EMAIL_CAUTION_LABEL}: ${CATCH_ALL_EMAIL_CAUTION_TOOLTIP}`
    : email;

  if (variant === "icon") {
    return (
      <span
        className={["contactEmail_row", "contactEmail_row--icon", className]
          .filter(Boolean)
          .join(" ")}
      >
        <span className="contactEmail_iconWrap">
          <a
            href={mailtoHref}
            title={iconTitle}
            className={linkClassName}
            onClick={onLinkClick}
          >
            <i className="fa-solid fa-envelope" />
          </a>
          {isCatchAll && (
            <span
              className="contactEmail_caution contactEmail_caution--iconBadge"
              title={CATCH_ALL_EMAIL_CAUTION_TOOLTIP}
              aria-label={CATCH_ALL_EMAIL_CAUTION_TOOLTIP}
            >
              <i className="fa-solid fa-triangle-exclamation" aria-hidden />
            </span>
          )}
        </span>
      </span>
    );
  }

  return (
    <span className={["contactEmail_row", className].filter(Boolean).join(" ")}>
      <a href={mailtoHref} className={linkClassName} onClick={onLinkClick}>
        {email}
      </a>
      {isCatchAll && (
        <span
          className="contactEmail_caution"
          title={CATCH_ALL_EMAIL_CAUTION_TOOLTIP}
          aria-label={CATCH_ALL_EMAIL_CAUTION_TOOLTIP}
        >
          <i className="fa-solid fa-triangle-exclamation" aria-hidden />
          <span className="contactEmail_cautionLabel">{CATCH_ALL_EMAIL_CAUTION_LABEL}</span>
        </span>
      )}
    </span>
  );
};
